import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Manifesto } from "@/components/Manifesto";
import { Departures } from "@/components/Departures";
import { Destinations } from "@/components/Destinations";
import { Calculator } from "@/components/Calculator";
import { Tracking } from "@/components/Tracking";
import { QuoteForm } from "@/components/QuoteForm";
import { Billing } from "@/components/Billing";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-abyss text-white min-h-screen">
      <div className="noise-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Manifesto />
        <Departures />
        <Destinations />
        <Calculator />
        <Tracking />
        <QuoteForm />
        <Billing />
      </main>
      <Footer />
    </div>
  );
}
